import styled from 'styled-components';
import ArrowBack from 'assets/images/appointment/arrow-back.svg';
import { CommonDiv } from 'styles/common';
import CancelSvg from 'assets/images/invoice/cancel.svg';
import AddSvg from 'assets/images/invoice/add.svg';
import SearchSvg from 'assets/images/invoice/search.svg';

const Container = styled.div`
  margin: 0 auto;
  max-width: 1600px;
  box-sizing: border-box;
  padding: 2.3em 1em;
  height: calc(100% - 62px);
`;

const ContentWrapper = styled.div`
  height: calc(100% - 82px);
  display: flex;
`;

const BreadCrumps = styled.div`
  margin-bottom: 39px;
  display: table;
`;

const ArrowBackImg = styled.img.attrs({
  src: ArrowBack
})`
  margin-right: 20px;
  cursor: pointer;
`;

const List = styled.ul`
  margin: 0;
  padding: 0;
  border-right: 1px solid ${props => props.theme.color.border};
  border-left: 1px solid ${props => props.theme.color.border};
`;
const Item = styled.li`
  list-style-type: none;
`;

const Table = styled.table`
  width: 100%;
  border-spacing: 0;
  position: relative;
  height: 100%;
  border: 1px solid ${props => props.theme.color.border};
  border-radius: 4px;
  tbody {
    display: block;
    position: absolute;
    height: calc(100% - 48px - 70px);
    overflow: auto;
  }
  thead, 
  tbody tr {
    height: 48px;
    display:table;
    border-bottom: 1px solid ${props => props.theme.color.border};
    width:100%;
    table-layout:fixed;
    &:last-of-type {
      border-bottom: none
    }
  }

  thead tr{
    border: none;
    cursor: default;
  }
  
  tr th:first-child,
  tr td:first-child {
    padding-left: 30px;
  }

  tfoot tr td {
    height: 69px;
      &:first-child {
      padding-left: 0;
    }
  }

  .caption-section {
    cursor: default;
    border-bottom: 0;
    td {
      color: ${props => props.theme.color.primary};
      padding: 17px 0 17px 0;
      font-size: 14px;
      text-align: left;
      font-size: 500;
    }
  }
`;

const CellTD = styled.td`
  padding: 16px 0 15px 0;
`;

const CellTH = styled.th`
  display: flex;
  background-color: ${props => props.theme.color.background};
  align-items: center;
  padding-right: ${props => props.scrollWidth ? '15px' : 0};
  span {
    display: block;
    font-size: 14px;
    text-align: left;
    padding: 16px 0px;
    color: ${props => props.theme.color.label};
    background-color: ${props => props.theme.color.background};
    font-weight: normal;
    &:nth-of-type(1)  {
      width: calc(47% - 15px); 
    }
    &:nth-of-type(2){
      width: calc(31% + 7px );
    }
    &:nth-of-type(3){
      width: 15%;
    }
    &:nth-of-type(4){
      width: 7%;
    }
  }
`;

const Row = styled.tr`
  cursor: pointer;
  background-color: ${props => props.isActive && props.theme.color.active};
`;

const CancelIcon = styled.img.attrs({
  src: CancelSvg
})`
`;

const AddIcon = styled.img.attrs({
  src: AddSvg
})`
`;

const TableNumber = styled(CommonDiv)`
  font-size: 14px;
  text-align: left;
  color: ${props => props.theme.color.label};
`;

const SearchBlock = styled.div`
  padding: 20px 29px;
  display: flex;
  border-top: 1px solid ${props => props.theme.color.border};
`;

const SearchInput = styled(CommonDiv.withComponent('input'))`
  border: 0;
  font-size: 24px;
  height: 28px;
  padding: 0;
  text-align: left;
  width: 100%;
  outline: none;
  ::-webkit-input-placeholder {
    /* Chrome/Opera/Safari */
    color: ${props => props.theme.color.label};
  }
  ::-moz-placeholder {
    /* Firefox 19+ */
    color: ${props => props.theme.color.label};
  }
  :-ms-input-placeholder {
    /* IE 10+ */
    color: ${props => props.theme.color.label};
  }
  :-moz-placeholder {
    /* Firefox 18- */
    color: ${props => props.theme.color.label};
  }
`;

const SearchIcon = styled.img.attrs({
  src: SearchSvg
})`
  width: 24px;
  height: 24px;
  margin: auto;
`;

export {
  Container,
  ContentWrapper,
  BreadCrumps,
  ArrowBackImg,
  CommonDiv,
  Table,
  Row,
  CellTD,
  CellTH,
  AddIcon,
  CancelIcon,
  TableNumber,
  List,
  Item,
  SearchBlock,
  SearchInput,
  SearchIcon,
};
